angular.module("UI8.components").component("creditPackTile", {
  template: `<div class="purchases__item">
    <a class="purchases__preview" ng-href="{{ $ctrl.toolUrl }}" target="_blank">
      <img ng-src="/img/ui8-credits.avif" alt="Credits">
    </a>
    <div class="purchases__inner">
      <div class="purchases__head">
        <div class="purchases__title">{{ $ctrl.pack.productName }}</div>
        <div class="purchases__price">{{ $ctrl.formattedAmount }}</div>
      </div>
      <div class="purchases__description">
        {{ $ctrl.toolLabel }}
        <span ng-if="$ctrl.pack.status === 'refunded'" style="color:#FF6A55;margin-left:8px">Refunded</span>
        · {{ $ctrl.formattedDate }}
      </div>
      <div class="purchases__actions" ng-if="$ctrl.showPortal">
        <button class="btn btn--stroke btn--icon-only" ng-click="$ctrl.onPortalClick()" ng-disabled="$ctrl.portalLoading">
          <svg><path fill-rule="evenodd" d="M15.241 1H8.759l-2.011.044c-.562.046-1.079.144-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.289 3 5.954 3 6.759v10.483l.044 2.011c.046.562.144 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.289 23 7.954 23 8.759 23h6.483l2.01-.044c.562-.046 1.079-.145 1.564-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.011V6.759l-.044-2.011c-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.711 1 16.046 1 15.241 1zM8 6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1z"/></svg>
        </button>
      </div>
    </div>
  </div>`,

  controller: function () {
    var ctrl = this;
    var TOOL_LABELS = { persona: "Persona", uidrop: "Drop 3D Studio" };

    ctrl.$onInit = function () {
      ctrl.toolLabel = TOOL_LABELS[ctrl.pack.tool] || ctrl.pack.tool;
      ctrl.toolUrl =
        ctrl.pack.tool === "uidrop"
          ? "https://drop.ui8.net/"
          : "https://persona.ui8.net/";

      var cents = ctrl.pack.amountCents || 0;
      ctrl.formattedAmount = "$" + (cents / 100).toFixed(2);
      ctrl.formattedDate = new Date(ctrl.pack.createdAt).toLocaleDateString(
        "en-US",
        {
          year: "numeric",
          month: "short",
          day: "numeric",
        }
      );
    };
  },

  bindings: {
    pack: "<",
    showPortal: "<",
    onPortalClick: "&",
    portalLoading: "<",
  },
});
